import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";

/**
 * Новый ключ организации — после создания и после перевыпуска.
 *
 * Ключ показывается один раз: сервер больше его не отдаст. Поэтому окно не
 * закрывается крестиком или кликом мимо, только кнопкой — чтобы ключ не потеряли
 * случайно, не скопировав.
 */
const IssuedKeyDialog = ({ issued, onClose }) => {
  const [copied, setCopied] = React.useState(false);

  React.useEffect(() => {
    setCopied(false);
  }, [issued]);

  const onCopy = () => {
    navigator.clipboard
      ?.writeText(issued.apiKey)
      .then(() => setCopied(true))
      .catch(() => setCopied(false));
  };

  const footer = (
    <Button label="Ключ сохранён, закрыть" icon="pi pi-check" onClick={onClose} />
  );

  return (
    <Dialog
      header={issued ? `Ключ организации ${issued.organization?.companyName}` : ""}
      visible={Boolean(issued)}
      onHide={onClose}
      closable={false}
      closeOnEscape={false}
      dismissableMask={false}
      footer={footer}
      style={{ width: "640px", maxWidth: "95vw" }}
    >
      {issued && (
        <div>
          <Message
            severity="warn"
            style={{ marginBottom: 12, width: "100%" }}
            text="Ключ показывается один раз. Скопируйте его и передайте партнёру защищённым каналом. Если ключ потеряют, поможет только перевыпуск."
          />
          <div className="p-d-flex p-ai-center" style={{ gap: 8 }}>
            <InputText
              value={issued.apiKey}
              readOnly
              onFocus={(e) => e.target.select()}
              style={{ flex: 1, fontFamily: "monospace" }}
            />
            <Button
              label={copied ? "Скопирован" : "Скопировать"}
              icon={copied ? "pi pi-check" : "pi pi-copy"}
              className={copied ? "p-button-success" : undefined}
              onClick={onCopy}
            />
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default IssuedKeyDialog;
